import { RootState } from '../../config/hooks';

export const getChooseSideOrders = (state: RootState) =>
  state.chooseSideOrdersSlice;

export const getChooseSideOrdersList = (state: RootState) =>
  getChooseSideOrders(state).list;

export const getChooseSideOrdersPriceOfSideOrders = (state: RootState) =>
  getChooseSideOrders(state).priceOfSideOrders;

export const getChooseSideOrdersNumberOfSideOrders = (state: RootState) =>
  getChooseSideOrders(state).numberOfSideOrders;

export const getChooseSideOrdersError = (state: RootState) =>
  getChooseSideOrders(state).error;

export const getChooseSideOrdersLimitedByMaximumSelectedMeals = (
  state: RootState
) => getChooseSideOrders(state).clearLimitedByMaximumSelectedMeals;
